<!--
 * @Author: your name
 * @Date: 2021-05-25 13:30:43
 * @LastEditTime: 2021-12-22 20:15:33
 * @LastEditors: fangshengchu
 * @Description: In User Settings Edit
 * @FilePath: \plantmate-shopping\src\views\modules\trainManagement\community\community.vue
-->
<template>
    <div class="community">
        <ul>
            <li :class="$route.name === 'ExpertsQuestion' ? 'router-active' : ''"><router-link to="./ExpertsQuestion">专家问答</router-link></li>
            <li :class="$route.name === 'PostBar' ? 'router-active' : ''"><router-link to="./PostBar">贴吧</router-link></li>
        </ul>
         <router-view :key="key"></router-view>
    </div>
</template>

<script>
import ExpertsQuestion from './ExpertsQuestion'
import PostBar from './PostBar'

export default {
  name: 'community',
  data () {
    return {
      // modules: false,
      key: new Date().getTime()
    }
  },
  watch: {
    '$route.query': {
      handler: 'routerWatchFun'
    }
  },
  methods: {
    routerWatchFun () {
      if (!this.$route.query.page) {
        this.key = new Date().getTime()
      }
    }
  },
  components: {
    ExpertsQuestion,
    PostBar
  }
}
</script>

<style scoped>
a {
  width: 100px;
  height: 40px;
  line-height: 40px;
  display: inline-block;
  color: #000;
  text-decoration: none;
  text-align: center;
  border: 1px solid #ccc;
}
.community {
  width: 1190px;
  margin: 0 auto;
  padding: 20px 0;
}
ul {
  display: flex;
}
ul > li:nth-of-type(1) {
  margin-right: 50px;
}
.router-link-exact-active.router-link-active {
  background-color: #1d65a8;
  color: #fff;
}
.router-active {
  background-color: #1d65a8;
  color: #fff;
}
.router-active a{
  color: #fff;
}
</style>
